import styled from "styled-components";
import TopHeader from "src/components/TopHeader";
import BestSmartfolios from "./containers/BestSmartfolios";
import GoalForm from "./containers/GoalForm";
import { useSelector } from "react-redux";
import { RootStateType } from "src/store/rootReducer";
import ContributionForm from "./containers/ContributionForm";
import SolveInitialForm from "./containers/SolveInitialForm";
import SolveDurationForm from "./containers/SolveDurationForm";
import { colors } from "src/theme/colors";
import { line, radii, shadow, space } from "src/theme/ui";

/* No slab behind the cards. The page's content is cards, and a white panel
   under a white card is the same box drawn twice. */
export const PageWrapper = styled.div`
  width: 100%;
`;

/**
 * The form, as one card.
 *
 * It had been a lavender panel holding a stack of white boxes — a card
 * inside a card, four times over, with the tint of the outer one supplying
 * the only separation between them. The panel is the card now and the fields
 * are rows in it, divided by hairlines: the same reading, drawn with one
 * object instead of five.
 */
export const StyledPredictionForm = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 420px;
  min-width: 0;
  max-width: 620px;
  border-radius: ${radii.lg}px;
  border: 1px solid ${line.hairline};
  box-shadow: ${shadow.card};
  background: ${colors.white};

  @media (max-width: 1200px) {
    max-width: none;
  }
`;

/**
 * One field in the form.
 *
 * The `color` and `opacity` props are gone with the tinted boxes that used
 * them: the two callers passed a translucent green — the colour this product
 * uses for a gain — around a required contribution and a projection, neither
 * of which is a gain.
 */
export const StyledFormSection = styled.div`
  padding: ${space.md}px ${space.lg}px;

  & + & {
    border-top: 1px solid ${line.hairline};
  }
`;

const StyledBody = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space.md}px;
  width: 100%;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

const Side = styled.div`
  flex: 1 1 520px;
  min-width: 0;
`;

const GoalBasedPredictions = () => {
  const menuState = useSelector((state: RootStateType) => state.menuReducer);
  return (
    <PageWrapper>
      <TopHeader />
      <StyledBody>
        {menuState.currentState === "GoalAmount" ? (
          <GoalForm />
        ) : menuState.currentState === "ContributionAmount" ? (
          <ContributionForm />
        ) : menuState.currentState === "SolveInitial" ? (
          <SolveInitialForm />
        ) : (
          <SolveDurationForm />
        )}
        {/* The recommendations, which need the room a chart-bearing column
            does not: the form is a fixed set of four short fields. */}
        <Side>
          <BestSmartfolios />
        </Side>
      </StyledBody>
    </PageWrapper>
  );
};

export default GoalBasedPredictions;
